import { loadProjects } from '../content/loadProjects'
import { formatStatus } from '../content/formatStatus'

export default function WorkSection() {
  const projects = loadProjects()

  return (
    <section id="work" data-testid="work" className="section section--work">
      <div className="section-heading">
        <h2>Work</h2>
        <p className="section-lede">Featured projects you can try and watch.</p>
      </div>
      <ul data-testid="work-list" className="work-list">
        {projects.map((project, index) => (
          <li key={project.slug} data-testid={`work-item-${project.slug}`} className="work-item">
            <span className="work-item__index" aria-hidden="true">
              {String(index + 1).padStart(2, '0')}
            </span>
            <div className="work-item__body">
              <a href={`#project-${project.slug}`} className="work-item__name">
                {project.displayName}
              </a>
              <span data-testid={`work-status-${project.slug}`} className="work-item__status">
                {formatStatus(project.status)}
              </span>
              <p className="work-item__summary">{project.summary}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
